import {
  AdminAppAction,
  EventActionType,
  UpdateEventErrorAction,
  UpdateEventRequestAction,
  UpdateEventSuccessAction,
  updateEventError,
  updateEventSuccess,
} from '../../actions';
import { Epic, ofType } from 'redux-observable';
import { LIST_EVENTS_QUERY, ListEventsData } from '../../queries';
import {
  UPDATE_EVENT_MUTATION,
  UpdateEventPayload,
  UpdateEventVariables,
} from '../../mutations';
import { getEventId, getUpdateEventInput } from '../../selectors';
import { AdminAppState } from '../../state';
import { EpicDependencies } from '../epic-dependencies';
import { MutationUpdaterFn } from 'apollo-client';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

const update = (
  variables: UpdateEventVariables,
): MutationUpdaterFn<UpdateEventPayload> => (cache, { data }) => {
  const query = cache.readQuery<ListEventsData>({
    query: LIST_EVENTS_QUERY,
  });
  if (data && query) {
    const edges = [...query.events.edges];
    for (const edge of edges) {
      if (edge.node.id === variables.id) {
        edge.node = {
          ...edge.node,
          ...variables.input,
        };
      }
    }
    cache.writeQuery<ListEventsData>({
      query: LIST_EVENTS_QUERY,
      data: {
        ...query,
        events: { ...query.events, edges },
      },
    });
  }
};

export const updateEventEpic: Epic<
  AdminAppAction,
  UpdateEventSuccessAction | UpdateEventErrorAction,
  AdminAppState,
  EpicDependencies
> = (
  action$,
  state,
  { client },
): Observable<UpdateEventSuccessAction | UpdateEventErrorAction> =>
  action$.pipe(
    ofType<AdminAppAction, UpdateEventRequestAction>(
      EventActionType.UpdateEventRequest,
    ),
    switchMap(async (action: UpdateEventRequestAction) => {
      const variables = {
        id: getEventId(action.eventKey)(state.value),
        input: getUpdateEventInput(action.eventKey)(state.value),
      };

      const { data, errors } = await client.mutate<
        UpdateEventPayload,
        UpdateEventVariables
      >({
        errorPolicy: 'all',
        mutation: UPDATE_EVENT_MUTATION,
        update: update(variables),
        variables,
      });

      if (errors) {
        return updateEventError(action.eventKey, errors);
      } else if (data) {
        return updateEventSuccess(action.eventKey);
      } else {
        throw new Error('No data.');
      }
    }),
  );
